<template>
  <div class="page">

    <div class="top">

      <div>
        <!-- Create new account -->
        <div class="form">
          <form class="form-inline" v-on:submit.prevent="createAccount()">
            <input v-model="name" size="50" placeholder="Account name"/>
            <button type="submit">Create new</button>
          </form>
        </div>
      </div>
    </div>

    <div class="accounts">

      <div class="top">
        <div>
          Accounts {{filteredAccounts.length}} of {{accounts.length}}
        </div>
        <div>
          <button @click="refreshAccounts">Refresh</button>
        </div>
      </div>
      <Account v-for="account in filteredAccounts" :key="account.id" :account="account" :subscriptions="subscriptions"/>
    </div>

  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.top {
  display: flex;
  justify-content: space-between;
}
.accounts {
  margin-top: 10px;
}
</style>

<script>
import { mapState } from 'vuex'
import Account from '@/components/Account.vue'

export default {
  name: 'accounts',
  components: {
    Account
  },
  computed: {
    filteredAccounts() {
      return this.accounts
    },
    ...mapState([
      'debugMode',
      'accounts',
      'subscriptions',
    ])
  },
  methods: {
    refreshAccounts () {
      this.$store.dispatch('loadAccounts')
    },
    createAccount () {
      if (!this.name) return
      this.$store.dispatch('createAccount', {
        name: this.name
      })
      this.name = ''
    }
  },
  data () {
    return {
      name: ''
    }
  }
}
</script>
